import { React, useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Loader from '../../Global/loader'
import './Index.scss'
import SVG from "react-inlinesvg";
import DangerSVG from './../../Images/svg/usklicnik.svg'
import { GetUserList, EditUser } from '../../Services/user';

const Delete = (data) => {
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [firstName] = useState("");
    const [lastName] = useState("");
    const [id, setId] = useState(0);
    const dispatch = useDispatch();

    const handleShow = async () => {
        setLoading(true);
        setShow(true);
        setId(data.data.id); 
        setLoading(false);
    }
    const handleClose = () => {
        setShow(false);
    }

    const handleSubmit = async (event) => {
        await setLoading(true);
     
        try{
            await EditUser(dispatch, { id, firstName, lastName });   
            await GetUserList(dispatch, null, null)
        }
        catch{            
        }

        await setLoading(false);
    }

    return (
        <>
        <Button variant="flat" className="btn" bsPrefix="edit" onClick={handleShow}>
            Izbriši osobne podatke
        </Button>
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            className="add-modal"
            centered
            size="mds"
        >
        {!loading ?
            <>
               
                <Form noValidate  onSubmit={handleSubmit}>
                    <Modal.Body>
                       <div style={{textAlign: "center", color:"white"}}>
                           <span> <SVG src={DangerSVG} /> Potvrdi brisanje osobnih podataka </span>
                       </div>
                    </Modal.Body>

                    <Modal.Footer style={{paddingBottom: "40px"}}>
                        <Button variant="flat" className="btn" bsPrefix="edit" type="submit" style={{width: "120px"}}>
                            Da
                        </Button>
                        <Button  variant="flat" className="btn" bsPrefix="delete" onClick={handleClose} style={{width: "120px"}}>
                            Otkaži
                        </Button>
                    </Modal.Footer>
                </Form>
            </>
            :
            <div className="loader-container ">
                <Loader />
             </div>
            }
        </Modal>
        </>
    );
};

export default Delete;